import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ResourceCategoryItem } from './resource-category-item';
export { ResourceCategoryItem };
import { resourceCategoryItemSchema } from '@schemas/business-objects/resource-category-item';
import { ResourceFormGroup } from './resource-form-group';
import { ResourceCategoryFormGroup } from './resource-category-form-group';
import type { TextBox } from './text-box';
import type { User } from './user';

export class ResourceCategoryItemFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    sequence: SchemaFormControl;
    locked: SchemaFormControl;
    resourceCategoryId: SchemaFormControl;
    resourceCategory: ResourceCategoryFormGroup;
    resourceId: SchemaFormControl;
    resource: ResourceFormGroup;
  };

  declare value: Partial<ResourceCategoryItem>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(resourceCategoryItemSchema, ResourceCategoryItem, data, options);
  }

  get object(): ResourceCategoryItem {
    return new ResourceCategoryItem(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'resourceCategory':
        return new ResourceCategoryFormGroup();
      case 'resource':
        return new ResourceFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ResourceCategoryItem[]> {
    return ResourceCategoryItem.find(filter);
  }

  static async findOne(filter?: any): Promise<ResourceCategoryItem | null> {
    return ResourceCategoryItem.findOne(filter);
  }

  static async findById(
    id: number,
    filter?: any,
  ): Promise<ResourceCategoryItem> {
    return ResourceCategoryItem.findById(id, filter);
  }

  static async create(
    data: Partial<ResourceCategoryItem>,
  ): Promise<ResourceCategoryItem> {
    return ResourceCategoryItem.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<ResourceCategoryItem>,
  ): Promise<ResourceCategoryItem> {
    return ResourceCategoryItem.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return ResourceCategoryItem.deleteById(id);
  }

  async dataForCopy(): Promise<any> {
    const instance = new ResourceCategoryItem(this.getRawValue());
    return instance.dataForCopy();
  }
}

export class ResourceCategoryItemFormArray extends PersistedFormArray {
  readonly entityName = 'ResourceCategoryItem' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(resourceCategoryItemSchema, ResourceCategoryItem, options);
  }

  protected override createItemGroup() {
    return new ResourceCategoryItemFormGroup();
  }

  get array(): ResourceCategoryItem[] {
    return this.controls.map(
      (group: ResourceCategoryItemFormGroup) => group.object,
    );
  }
}

export class ResourceCategoryItemPersistedArray extends PersistedArray<ResourceCategoryItem> {
  readonly entityName = 'ResourceCategoryItem' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ResourceCategoryItem, options);
  }
}
